module.exports = __webpack_public_path__ + "img/logo_grey.5b709239.png";